import React, { useRef, useEffect, useState, useCallback } from "react";
import { useInView } from "framer-motion";

function parseNumericValue(str) {
  const match = str.match(/([\d.]+)/);
  if (!match) return null;
  return parseFloat(match[1]);
}

export default function CountUp({
  value,
  duration = 1.8,
  className = "",
  style,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });
  const [display, setDisplay] = useState(value);

  const animate = useCallback(() => {
    const numericPart = parseNumericValue(value);
    if (numericPart === null) return;

    const numStr = String(numericPart);
    const prefix = value.substring(0, value.indexOf(numStr.charAt(0)));
    const suffix = value.substring(value.indexOf(numStr) + numStr.length);
    const isInt = Number.isInteger(numericPart);
    const decimals = !isInt && numStr.includes(".") ? numStr.split(".")[1].length : 0;

    const startTime = performance.now();
    const ms = duration * 1000;

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / ms, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = numericPart * eased;

      if (progress < 1) {
        setDisplay(`${prefix}${isInt ? Math.round(current) : current.toFixed(decimals)}${suffix}`);
        requestAnimationFrame(tick);
      } else {
        setDisplay(value);
      }
    }

    requestAnimationFrame(tick);
  }, [value, duration]);

  useEffect(() => {
    if (isInView) {
      animate();
    }
  }, [isInView, animate]);

  return (
    <span ref={ref} className={className} style={style}>
      {display}
    </span>
  );
}
